import { cn } from "@/lib/utils";

import { MarketingLink } from "./MarketingButton";
import {
  MarketingSection,
  SectionKicker,
  SectionTitle,
} from "./MarketingSection";
import { productIcons } from "./productIcons";
import {
  MARKETING_PRODUCTS,
  WORKFLOW_PRODUCTS,
  type MarketingProductKey,
} from "./products";
import { Trademark } from "./ToolCard";

const TINTS = [
  "bg-[linear-gradient(145deg,#fff,#eef0ff)]",
  "bg-[linear-gradient(145deg,#fff,#fff0f7)]",
  "bg-[linear-gradient(145deg,#fff,#f4ffe4)]",
];

export default function RelatedProducts({
  current,
}: {
  current?: MarketingProductKey;
}) {
  const keys = WORKFLOW_PRODUCTS.filter((key) => key !== current);
  return (
    <MarketingSection className="bg-white !py-20">
      <SectionKicker>Keep moving</SectionKicker>
      <SectionTitle>Part of the complete Lutely workflow.</SectionTitle>
      <div className="mt-9 grid grid-cols-3 gap-[17px] max-[980px]:grid-cols-2 max-[680px]:grid-cols-1">
        {keys.map((key, i) => {
          const product = MARKETING_PRODUCTS[key];
          return (
            <MarketingLink
              key={key}
              to={product.path}
              className={cn(
                "group relative min-h-[190px] rounded-[24px] border border-marketing-line px-[25px] pb-[54px] pt-[25px] shadow-[0_10px_34px_rgba(15,26,75,0.06)] outline-none transition-[transform,border-color,box-shadow] duration-200 hover:border-[rgba(48,66,226,0.5)] hover:shadow-[0_18px_42px_rgba(15,26,75,0.14)] focus-visible:border-[rgba(48,66,226,0.5)] motion-safe:hover:-translate-y-1 motion-safe:focus-visible:-translate-y-1",
                TINTS[i % 3],
              )}
            >
              <div className="flex items-start justify-between gap-[18px]">
                <div>
                  <small className="font-open-sans text-[13px] font-black uppercase text-blue-600">
                    {product.category}
                  </small>
                  <h3 className="mt-[9px] font-open-sans text-[23px] font-bold leading-[1.15] text-marketing-ink">
                    {product.relatedName ?? product.cardName}
                    {product.trademark && <Trademark />}
                  </h3>
                </div>
                <div className="grid size-[42px] shrink-0 place-items-center rounded-[12px] bg-marketing-lavender text-marketing-purple [&_svg]:size-[23px]">
                  {productIcons[product.icon]}
                </div>
              </div>
              <span className="absolute bottom-[21px] left-[25px] translate-y-[5px] font-open-sans text-[16px] font-[850] text-blue-600 opacity-0 transition-[opacity,transform] duration-200 group-hover:translate-y-0 group-hover:opacity-100 group-focus-visible:translate-y-0 group-focus-visible:opacity-100 [@media(hover:none)]:translate-y-0 [@media(hover:none)]:opacity-100">
                Learn more →
              </span>
            </MarketingLink>
          );
        })}
      </div>
    </MarketingSection>
  );
}
